export const isTestMode = (): boolean => process.env.NODE_ENV === 'test'
